export function Footer() {
  return (
    <footer className="border-t border-rule py-8 mt-20">
      <div className="max-w-6xl mx-auto px-12 flex justify-between items-baseline flex-wrap gap-4 font-label text-xs text-ink-muted">
        <div>© 2026 Ashutosh "Ash" Pandey · Notes from twenty years of paying attention.</div>
        <div className="flex gap-4 items-baseline">
          <a href="https://prajnainnovates.com/privacy.html#security" className="underline underline-offset-2 hover:text-ink">
            Privacy and security
          </a>
          <span className="tracking-widest">California</span>
        </div>
      </div>
    </footer>
  );
}
